<template>
  <div>
    <b-card
      no-body
      class="liveinfo-form"
    >
      <div class="m-2">
        <b-row>
          <b-col
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <p class="h5 mt-50 mr-75 ml-50">
              조회 타입
            </p>
            <b-form-radio-group
              v-model="query.isPrefixSum"
            >
              <b-form-radio :value="true">
                누적
              </b-form-radio>
              <b-form-radio :value="false">
                일별
              </b-form-radio>
            </b-form-radio-group>
            <p class="h5 mt-50 mr-75 ml-50">
              조회 기준
            </p>
            <b-form-radio-group
              v-model="query.searchType"
            >
              <b-form-radio :value="1">
                의원
              </b-form-radio>
              <b-form-radio :value="2">
                의사
              </b-form-radio>
            </b-form-radio-group>
          </b-col>
        </b-row>
        <b-row class="mt-1">
          <b-col
            md="10"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <v-select
              v-model="query.clientId"
              :options="codes.clients"
              placeholder="제약사"
              :reduce="option => option.code"
              class="el-def"
              style="width: 430px"
            />
            <v-select
              v-model="query.status"
              :options="codes.status"
              placeholder="진행 상태"
              :reduce="option => option.code"
              class="el-def"
            />
            <b-form-datepicker
              v-model="query.searchStartDate"
              class="el-def"
              placeholder="진행기간(Fr)"
              style="width: 250px"
            />
            <label class="ml-25 mr-50">~</label>
            <b-form-datepicker
              v-model="query.searchEndDate"
              class="el-def"
              placeholder="진행기간(To)"
              style="width: 250px"
            />
            <label style="width: 160px">(*당일데이터 조회 불가)</label>
          </b-col>
          <b-col
            md="2"
            class="d-flex align-items-center justify-content-end"
          >
            <b-button
              variant="outline-dark"
              class="btn-search ml-1"
              @click.prevent="excelDownload()"
            >
              <feather-icon
                icon="DownloadIcon"
                class="mr-50"
              />
              <span>엑셀 다운로드</span>
            </b-button>
          </b-col>
        </b-row>
      </div>
    </b-card>
    <b-card>
      <div>
        <b-row>
          <b-col
            cols="12"
            md="6"
          >
            해당 통계는 엑셀 다운로드만 제공됩니다.
          </b-col>
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import axios from '@axios'
import vSelect from 'vue-select'
import { onMounted, ref } from '@vue/composition-api'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import dayjs from 'dayjs'
import { saveAs } from "file-saver"

export default {
  components: {
    vSelect,
  },

  setup() {
    onMounted(() => {
      fetchCodes()
    })

    const toast = useToast()
    const pushToast = (variant, title) => {
      let icon

      if (variant === 'success') {
        icon = 'CheckCircleIcon'
      } else {
        icon = 'AlertTriangleIcon'
      }

      toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    }

    const query = ref({
      isPrefixSum: true,
      searchType: 1,
      clientId: null,
      status: null,
      searchStartDate: dayjs().add(-1, 'month').format('YYYY-MM-DD'),
      searchEndDate: dayjs().add(-1, 'day').format('YYYY-MM-DD'),
    })

    const codes = ref({
      clients: [],
      status: [],
    })

    const searchType = ref(1)

    const fetchCodes = () => {
      axios.get('/fa/webseminar/codes')
        .then(rs => {
          const {
            webSeminarStatus,
            clients,
          } = rs.data

          codes.value.status = webSeminarStatus.filter(e => e.code !== 90)
          codes.value.clients = clients
        })
        .catch(() => {
          pushToast('danger', '코드 데이터를 불러오는데 실패하였습니다.')
        })
    }

    const excelDownload = () => {
      const frDate = dayjs(query.value.searchStartDate)
      const toDate = dayjs(query.value.searchEndDate)

      if (Math.abs(frDate.diff(toDate, 'day')) > 90) {
        pushToast('warning', '조회 기간은 최대 90일을 넘을 수 없습니다.')
        return
      }

      axios.get(`/fa/statistics/seminar/excel`, {
        params: {
          isPrefixSum: query.value.isPrefixSum,
          searchType: query.value.searchType,
          clientId: query.value.clientId,
          status: query.value.status,
          startDate: query.value.searchStartDate,
          endDate: query.value.searchEndDate,
        },
        responseType: 'blob',
      })
        .then(rs => {
          if (rs?.data?.size > 0) {
            const blob = new Blob([rs.data])
            saveAs(blob, `웹심포지엄 통계(${query.value.isPrefixSum === true ? '누적' : '일별'}).xlsx`)
          }
        })
        .catch(() => {
          pushToast('danger', '데이터 조회 중 오류가 발생하였습니다.')
        })
    }

    return {
      query,
      codes,
      searchType,
      fetchCodes,
      excelDownload,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
